/** Resolve when the subscription request settles; notification is an independent snapshot.
 * A deadline bounds the UI wait without asserting failure for pending work.
 * The underlying deliveries continue; a retry may reach an already-accepted
 * address, which the subscribe endpoint handles idempotently.
 */
export function settleCaptureDelivery(
  list: Promise<boolean>,
  notification: Promise<boolean>,
  deadlineMs = 8000,
): Promise<{ accepted: boolean; notified: boolean; pending: boolean }> {
  return new Promise((resolve) => {
    let accepted = false
    let notified = false
    let resolved = false
    const finish = (pending: boolean) => {
      if (resolved) return
      resolved = true
      clearTimeout(timer)
      resolve({ accepted, notified, pending })
    }
    const timer = setTimeout(() => finish(true), deadlineMs)
    const receive = (sink: 'list' | 'notification', ok: boolean) => {
      if (sink === 'list') accepted = ok
      else notified = ok
      if (sink === 'list') finish(false)
    }
    void list.then((ok) => receive('list', ok), () => receive('list', false))
    void notification.then((ok) => receive('notification', ok), () => receive('notification', false))
  })
}
